// Kiswahili (docs/plans/phase3-portal-feedback-kiswahili.md §8; ADR 0035).
//
// TODO(language-verify): every string here is machine quality until a native speaker who
// knows Kenyan health-facility usage reviews it. review.ts lists what has been reviewed and
// which terms were deliberately left in English. Keep `{placeholders}` exactly as in en.ts.
// Never translate drug names, test names, codes, identifiers, units or facility names.

import type { MessageKey } from './en.ts';

export const sw: Record<MessageKey, string> = {
  // --- Languages ----------------------------------------------------------------------------
  'language.label': 'Lugha',
  'language.en': 'English',
  'language.sw': 'Kiswahili',
  'language.saved': 'Lugha imehifadhiwa',
  'language.description':
    'Lugha ya menyu, vichwa vya kurasa na vitufe vya kawaida. Kurasa nyingi bado ziko kwa Kiingereza.',
  'language.machineNotice':
    'Maneno ya Kiswahili bado hayajakaguliwa na mzungumzaji asilia. Ripoti chochote kinachosomeka vibaya.',

  // --- Staff shell ---------------------------------------------------------------------------
  'shell.skipToContent': 'Ruka hadi maudhui',
  'shell.menu': 'Menyu',
  'shell.closeMenu': 'Funga menyu',
  'shell.expandSidebar': 'Panua upau wa pembeni',
  'shell.collapseSidebar': 'Kunja upau wa pembeni',
  'shell.mainNavigation': 'Kuu',
  'shell.facility': 'Kituo: {name}',
  'shell.account': 'Akaunti: {name}',
  'shell.accountAndAppearance': 'Akaunti na mwonekano',
  'shell.signOut': 'Toka',
  'shell.facilityChanged': 'Kituo kimebadilishwa',
  'shell.nowWorkingAt': 'Sasa unafanya kazi {name}',
  'shell.offline':
    'Hakuna mtandao. Rasimu zinahifadhiwa kwenye kifaa hiki. Kuhifadhi kwenye Wodi kunasubiri mtandao.',
  'shell.offlineWaiting':
    'Hakuna mtandao. Rasimu zinahifadhiwa kwenye kifaa hiki, na {count} zilizohifadhiwa hapa zitatumwa mtandao ukirudi.',
  'shell.sending': 'Inatuma {count} zilizohifadhiwa kwenye kifaa hiki.',
  'shell.action': 'kitendo 1',
  'shell.actions': 'vitendo {n}',

  'nav.group.frontDesk': 'Mapokezi',
  'nav.group.clinical': 'Kliniki',
  'nav.group.pharmacyStores': 'Famasia na stoo',
  'nav.group.billingClaims': 'Malipo na madai',
  'nav.group.reports': 'Ripoti',
  'nav.group.administration': 'Utawala',
  'nav.home': 'Mwanzo',
  'nav.reception': 'Mapokezi',
  'nav.recordMerges': 'Kuunganisha rekodi',
  'nav.appointments': 'Miadi',
  'nav.records': 'Rekodi',
  'nav.charts': 'Faili za wagonjwa',
  'nav.referrals': 'Rufaa',
  'nav.deathsAndBirths': 'Vifo na vizazi',
  'nav.feedback': 'Maoni',
  'nav.casualty': 'Casualty',
  'nav.queue': 'Foleni',
  'nav.lab': 'Maabara',
  'nav.imaging': 'Imaging',
  'nav.wards': 'Wodi',
  'nav.theatre': 'Theatre',
  'nav.maternity': 'Wodi ya wazazi',
  'nav.mortuary': 'Chumba cha maiti',
  'nav.pharmacy': 'Famasia',
  'nav.stores': 'Stoo',
  'nav.procurement': 'Ununuzi',
  'nav.cashier': 'Keshia',
  'nav.approvals': 'Idhini',
  'nav.claims': 'Madai',
  'nav.insurance': 'Bima',
  'nav.reports': 'Ripoti',
  'nav.staff': 'Wafanyakazi',
  'nav.settings': 'Mipangilio',

  'page.home': 'Mwanzo',
  'page.welcome': 'Karibu, {name}',
  'page.account': 'Akaunti',
  'page.accountDescription': 'Mipangilio yako binafsi.',
  'page.patientPortal': 'Tovuti ya mgonjwa',
  'page.feedback': 'Maoni',

  // --- Common actions and states -----------------------------------------------------------
  'common.tryAgain': 'Jaribu tena',
  'common.cancel': 'Ghairi',
  'common.close': 'Funga',
  'common.save': 'Hifadhi',
  'common.back': 'Rudi',
  'common.loading': 'Inapakia',
  'common.reloadPage': 'Pakia ukurasa upya',
  'common.goHome': 'Nenda ukurasa wa mwanzo',

  // --- Errors --------------------------------------------------------------------------------
  'error.title': 'Kuna tatizo',
  'error.screenStopped':
    'Skrini hii imeacha kufanya kazi kwa sababu ya tatizo katika Wodi. Pakia ukurasa upya ili kuendelea. Likiendelea kutokea, ripoti tatizo kwa msimamizi wako.',
  'error.notFoundTitle': 'Ukurasa haupatikani',
  'error.notFoundBody':
    'Hakuna ukurasa kwenye anwani hii. Kagua kiungo, au anza tena kutoka ukurasa wa mwanzo.',
  'error.generic': 'Kuna tatizo. Jaribu tena.',
  'errors.offline': 'Wodi haipatikani. Kagua mtandao, kisha ujaribu tena.',
  'errors.not_signed_in': 'Muda wako umeisha. Ingia tena ili kuendelea.',
  'errors.forbidden': 'Huna ruhusa ya kufanya hili. Muulize msimamizi ukihitaji.',
  'errors.rate_limited': 'Majaribio mengi mno. Subiri dakika moja, kisha ujaribu tena.',
  'errors.service_unavailable': 'Huduma hii haipatikani kwa sasa. Jaribu tena baadaye.',
  'errors.internal_error': 'Kuna tatizo katika Wodi. Jaribu tena; likiendelea, liripoti.',
  'errors.not_found': 'Hilo halikupatikana. Huenda limeondolewa, au kiungo si sahihi.',
  'errors.invalid_credentials':
    'Hiyo si sahihi, au akaunti imefungwa baada ya majaribio mengi. Kagua na ujaribu tena.',

  // --- Staff sign-in ------------------------------------------------------------------------
  'signIn.title': 'Ingia',
  'signIn.email': 'Barua pepe',
  'signIn.password': 'Nenosiri',
  'signIn.submit': 'Ingia',
  'signIn.pending': 'Inaingia…',
  'signIn.emailInvalid': 'Andika anwani yako ya barua pepe, kama name@example.test.',
  'signIn.passwordMissing': 'Andika nenosiri lako.',
  'signIn.forgot': 'Umesahau nenosiri? Muombe msimamizi wa kituo chako alibadilishe.',
  'signIn.reason.expired': 'Muda wako umeisha. Ingia tena ili kuendelea.',
  'signIn.reason.expired_unsent':
    'Muda wako umeisha. Vitendo vilivyohifadhiwa kwenye kifaa hiki ambavyo havikutumwa kwa Wodi vimefutwa. Baada ya kuingia, kagua rekodi ya mgonjwa na uviingize tena.',
  'signIn.reason.signed_out': 'Umetoka.',

  // --- Patient portal ------------------------------------------------------------------------
  'portal.title': 'Tovuti ya mgonjwa',
  'portal.loadingFacility': 'Inapakia tovuti ya mgonjwa',
  'portal.unknownAddress':
    'Anwani hii ya tovuti ya mgonjwa si sahihi, au tovuti imezimwa. Thibitisha anwani na kituo.',
  'portal.signIn.heading': 'Ingia uone miadi, bili na majibu yako',
  'portal.signIn.phone': 'Nambari yako ya simu',
  'portal.signIn.phoneHelp': 'Nambari ambayo kituo kina kwako. Tutatuma msimbo kwa SMS.',
  'portal.signIn.phoneInvalid': 'Andika nambari ya simu ya Kenya, kwa mfano 0712 345 678.',
  'portal.signIn.sendCode': 'Tuma msimbo',
  'portal.signIn.sending': 'Inatuma…',
  'portal.signIn.codeSent':
    'Ikiwa nambari hii imesajiliwa kwa tovuti, msimbo unakuja kwa SMS. Unafanya kazi kwa dakika 5.',
  'portal.signIn.code': 'Msimbo kutoka SMS',
  'portal.signIn.codeInvalid': 'Andika tarakimu 6 kutoka kwenye SMS.',
  'portal.signIn.submit': 'Ingia',
  'portal.signIn.pending': 'Inaingia…',
  'portal.signIn.resend': 'Tuma msimbo mpya',
  'portal.signIn.resendIn': 'Unaweza kuomba msimbo mpya baada ya sekunde {seconds}.',
  'portal.signIn.otherNumber': 'Tumia nambari nyingine',
  'portal.signIn.notRegistered':
    'Hukupata msimbo? Uliza kituoni usajiliwe kwa tovuti ya mgonjwa. Unahitaji kukubali huko.',
  'portal.signedOut': 'Umetoka.',
  'portal.sessionEnded': 'Umetolewa baada ya dakika 15 bila kutumia. Ingia tena.',
  'portal.signOut': 'Toka',
  'portal.whose': 'Rekodi za nani',
  'portal.yourself': 'Wewe',
  'portal.child': 'Mtoto',
  'portal.patientNumber': 'Nambari ya mgonjwa',
  'portal.offline':
    'Hauko mtandaoni. Unachoona huenda si cha sasa. Unganisha upya ili kupakia vya karibuni.',

  'portal.appointments.title': 'Miadi ijayo',
  'portal.appointments.empty': 'Hakuna miadi ijayo.',
  'portal.appointments.with': 'Na {name}',
  'portal.appointments.kind.new': 'Ziara mpya',
  'portal.appointments.kind.follow_up': 'Ufuatiliaji',
  'portal.appointments.cancel': 'Ghairi miadi',
  'portal.appointments.cancelTitle': 'Ghairi miadi hii?',
  'portal.appointments.cancelBody':
    'Kituo kitaona kwamba umeighairi. Ili kupanga tena, piga simu au tembelea kituo.',
  'portal.appointments.cancelReason': 'Sababu (si lazima)',
  'portal.appointments.keep': 'Iache',
  'portal.appointments.cancelled': 'Miadi imeghairiwa',

  'portal.bills.title': 'Bili na malipo',
  'portal.bills.empty': 'Hakuna bili za kuonyesha.',
  'portal.bills.totalOwed': 'Bado kulipa: {amount}',
  'portal.bills.nothingOwed': 'Hakuna cha kulipa kwenye bili zinazoonyeshwa.',
  'portal.bills.onlyShown':
    'Hapa zinaonyeshwa bili unazoweza kuona hapa. Kwa taarifa kamili, uliza kwa keshia.',
  'portal.bills.visit': 'Ziara {number}',
  'portal.bills.payer': 'Analipa: {name}',
  'portal.bills.item': 'Bidhaa',
  'portal.bills.youPay': 'Unalipa',
  'portal.bills.covered': 'Imelipiwa',
  'portal.bills.cancelledLine': 'Imeghairiwa',
  'portal.bills.due': 'Sehemu yako',
  'portal.bills.paid': 'Umelipa',
  'portal.bills.owed': 'Bado kulipa',
  'portal.bills.unpriced': 'Baadhi ya bidhaa bado hazina bei, kwa hivyo kiasi kinaweza kubadilika.',
  'portal.bills.receipts': 'Malipo',
  'portal.bills.receipt': 'Risiti {number}',
  'portal.bills.howToPay':
    'Lipa kwa M-Pesa: Lipa na M-Pesa, Pay Bill, nambari ya biashara {paybill}, nambari ya akaunti {account}.',
  'portal.bills.payAtFacility': 'Lipa kwa keshia wa kituo.',
  'portal.bills.notProcessor': 'Unalipa kituo moja kwa moja. Wodi haichukui pesa zako kamwe.',

  'portal.results.title': 'Majibu ya maabara',
  'portal.results.empty': 'Hakuna majibu ya maabara ya kuonyesha.',
  'portal.results.whatIsShown':
    'Yanaonyeshwa tu majibu ambayo maabara imekagua na kutoa. Baadhi ya majibu utaelezwa ukiwa kituoni badala yake. Muulize mhudumu wako wa afya maana ya majibu yako.',
  'portal.results.test': 'Kipimo',
  'portal.results.result': 'Jibu',
  'portal.results.range': 'Kiwango cha kawaida',
  'portal.results.withheld': 'Uliza kituoni',
  'portal.results.released': 'Yalitolewa {date}',
  'portal.results.culture': 'Kuotesha vijidudu',
  'portal.results.culture.no_growth': 'Hakuna kilichoota',
  'portal.results.culture.growth': 'Vilivyoota: {organisms}',
  'portal.results.culture.pending': 'Bado haijakamilika',
  'portal.results.culture.sensitivities':
    'Muulize mhudumu wako wa afya kuhusu dawa zilizojaribiwa.',
  'portal.results.flag.normal': '',
  'portal.results.flag.low': 'Chini',
  'portal.results.flag.high': 'Juu',
  'portal.results.flag.abnormal': 'Si kawaida',
  'portal.results.flag.no_range': '',
  'portal.results.flag.not_applicable': '',
  'portal.results.flag.critical_low': '',
  'portal.results.flag.critical_high': '',
  'portal.results.flag.critical': '',

  'portal.allergies.title': 'Mzio',
  'portal.allergies.none': 'Hakuna mzio unaojulikana',
  'portal.allergies.notRecorded': 'Mzio haujarekodiwa',
  'portal.allergies.notRecordedHelp': 'Kiambie kituo kuhusu mzio wowote utakapokuja tena.',
  'portal.allergies.reaction': 'Athari: {reaction}',
  'portal.allergies.high': 'Hatari kubwa',
  'portal.allergies.unconfirmed': 'Bado haujathibitishwa',

  'portal.feedback.title': 'Maoni yako',
  'portal.feedback.waiting': 'Ziara yako ya {date} katika {facility} ilikuwaje?',
  'portal.feedback.noneWaiting': 'Hakuna ziara zinazosubiri maoni yako.',
  'portal.feedback.rate': 'Toa alama ya ziara hii',
  'portal.feedback.given': 'Ulitoa alama ya ziara yako ya {date}: {rating}',
  'portal.feedback.reply': 'Jibu kutoka kituo: {reply}',

  'feedback.rating': 'Alama yako',
  'feedback.rating.1': 'Mbaya sana',
  'feedback.rating.2': 'Mbaya',
  'feedback.rating.3': 'Wastani',
  'feedback.rating.4': 'Nzuri',
  'feedback.rating.5': 'Nzuri sana',
  'feedback.ratingMissing': 'Chagua alama.',
  'feedback.comment': 'Chochote unachotaka kutuambia (si lazima)',
  'feedback.commentHelp': 'Tafadhali usiandike kuhusu afya yako hapa. Hadi herufi 1000.',
  'feedback.send': 'Tuma maoni',
  'feedback.sending': 'Inatuma…',
  'feedback.thanks': 'Asante. Maoni yako yametumwa kwa kituo.',
  'feedback.link.title': 'Toa alama ya ziara yako',
  'feedback.link.about': 'Ziara yako katika {facility} tarehe {date}',
  'feedback.link.loading': 'Inakagua kiungo chako',
  'feedback.link.gone':
    'Kiungo hiki kimeisha muda au kimeshatumika. Unaweza kutoa maoni ukiwa kituoni.',
};
